import { css } from 'styled-components';
import { semanticElementMixin } from './semanticElementMixin';

/** @mixin semanticChildrenMixin */
/**
 * Adds styling for semantic elements as children of the component.
 *
 * @example
 * import { semanticChildrenMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${semanticChildrenMixin}
 * `;
 *
 * <Component>
 *    <strong>Important:</strong> Semantics <em>are</em> important!
 * </Component>
 *
 * @method
 * @return {CSSObject}
 */
export var semanticChildrenMixin = function semanticChildrenMixin(props) {
  return css(["strong,b{", "}em,i{", "}"], semanticElementMixin(Object.assign({}, props, {
    as: 'strong'
  })), semanticElementMixin(Object.assign({}, props, {
    as: 'em'
  })));
};